import React, { useState, useEffect } from 'react';
import Skeleton from '../OtherElements/CustomSkeleton';
import axios from '../../api/axios';
import Select from 'react-select';
import FormHelperText from '@material-ui/core/FormHelperText';

const SelectCargo = ({
  cargo,
  onSelect,
  disabled = false,
  error = false,
  helperText = '',
}) => {
  const [cargos, setCargos] = useState(null);
  const load = async () => {
    try {
      const { data } = await axios.get(`/api/v1/admin/cargo/type/list`);
      !!data && setCargos(data);
    } catch (error) {
      console.error(JSON.stringify(error, null, 2));
    }
  };
  const handleSelect = (option) => {
    const cargo = cargos.find((c) => c._id === option.value);
    onSelect(cargo);
  };

  useEffect(() => {
    load();
  }, []);
  return (
    <>
      {!!cargos ? (
        <div>
          <Select
            options={cargos.map((cargo) => ({
              label: cargo.title,
              value: cargo._id,
            }))}
            isMulti={false}
            isSearchable={true}
            placeholder="نوع محموله"
            value={!!cargo ? { label: cargo.title, value: cargo._id } : null}
            onChange={(cargo) => handleSelect(cargo)}
            noOptionsMessage={() => 'محموله یافت نشد.'}
            isDisabled={disabled}
            styles={{
              menu: (provided, state) => ({
                ...provided,
                zIndex: 2,
              }),
            }}
          />
          {error ? <FormHelperText error>{helperText}</FormHelperText> : null}
        </div>
      ) : (
        <Skeleton height={50} />
      )}
    </>
  );
};

export default SelectCargo;
